import moment from "moment";
import { MoreOptions, TableTitle } from "../../../components/Component";
import { TIME_FORMAT_GLOBAL, convertDropValue, dateToShow } from "../../../utils";
import { apiService } from "../../../services/api";
import { APIServicePath } from "../../../services/api/api-service-impl";
import { toPageInfo } from "../../_common/DataConverter";
import { JobStatusType, ShiftTypes, TimesheetStatusType, Weekdays } from "../../../utils/Utils";
import { JobType } from "./JobList";
import { convertHexToColor, isTextSelected, toCapitalize } from "../../../utils/Functions";
import { GradeBadge } from "../../../components/badge/GradeBadge";
import { UserActionType, UserPermissionType, isAllowToAccess } from "../../../services/permission/permission";

export const jobTableData = (type, status, onEdit, onViewClick, onCopy, onArchive, onMoveBack) => {
  const jobStatus = status ? status : { id: 1, label: "Open", value: "OPEN" };

  const onView = (row) => {
    if (isTextSelected()) {
      return;
    }
    onViewClick(row);
  };

  return [
    {
      name: <TableTitle title={"Request Id"} />,
      id: "refId",
      selector: (row) => (row?.refId ? row?.refId : "N/A"),
      sortable: true,
      style: {
        cursor: "pointer",
      },
      sortFunction: (rowA, rowB) => 0,
    },
    {
      name: <TableTitle title={"Carer"} />,
      selector: (row) => {
        if (row?.status === "COMPLETED") {
          return (
            <>
              <span>{row?.grade?.label}</span>
              <br />
              <span className="listingsubtext">{row?.ward?.name}</span>
            </>
          );
        } else {
          return (
            <>
              <span>-</span>
            </>
          );
        }
      },
      omit: !type ? true : false,
      sortable: false,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: <TableTitle title={"Client"} />,
      id: "clientName",
      selector: (row) => row?.client?.label,
      omit: type === JobType.hospital ? true : false,
      sortable: true,
      style: {
        cursor: "pointer",
      },
      sortFunction: (rowA, rowB) => 0,

      // grow: 1,
      //wrap: true,
    },
    {
      name: <TableTitle title={"Ward/Unit Name"} />,
      id: "wardName",
      selector: (row) => row?.ward?.name || row?.unitName,
      sortable: true,
      omit: type ? true : false,
      style: {
        cursor: "pointer",
      },
      sortFunction: (rowA, rowB) => 0,

      // grow: 1,
      // wrap: true,
    },

    {
      name: <TableTitle title={"Grade/Carer Type"} />,
      id: "grade",
      selector: (row) => {
        const displayLabel = row?.grade?.label || row?.carerType?.label;
        const displayColor = row?.grade?.colourHex || null;

        return (
          <GradeBadge
            label={displayLabel}
            color={displayColor ? `outline-${convertHexToColor(displayColor)}` : "outline-secondary"}
            onClick={() => onView(row)}
          />
        );
      },
      sortable: false,
      omit: type ? true : false,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: <TableTitle title={"Grade/Ward"} />,
      selector: (row) => {
        return (
          <>
            <div onClick={() => onView(row)}>
              <span>{row?.grade?.label}</span>
              <br />
              <span className="listingsubtext">{row?.ward?.name}</span>
            </div>
          </>
        );
      },
      omit: !type ? true : false,
      sortable: false,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: <TableTitle title={"Shift"} />,
      selector: (row) => {
        const startDate = row?.fromDate ? dateToShow(row?.fromDate) : "";
        const shiftType = row?.shiftType?.value;
        const startTime = row?.startTime ? moment(row?.startTime).format(TIME_FORMAT_GLOBAL) : "";
        const endTime = row?.endTime ? moment(row?.endTime).format(TIME_FORMAT_GLOBAL) : "";
        const icon = (
          <img
            src={
              shiftType === "DAY"
                ? require("../../../assets/images/jsTree/shiftIcon/Sun.png")
                : require("../../../assets/images/jsTree/shiftIcon/Moon.png")
            }
          />
        );

        return (
          <div onClick={() => onView(row)}>
            <span>{startDate}</span>
            <br />
            <span>
              {icon}
              <span className="ms-2">
                {startTime} - {endTime}
              </span>
            </span>
          </div>
        );
      },
      omit: !type ? true : false,
      sortable: false,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: <TableTitle title={"Start Date"} />,
      id: "date",
      selector: (row) => {
        const startDate = row?.fromDate ? dateToShow(row?.fromDate) : "";
        return `${startDate}`;
      },
      omit: type ? true : false,
      sortable: true,
      style: {
        cursor: "pointer",
      },
      sortFunction: (rowA, rowB) => 0,
    },
    {
      name: <TableTitle title={"Shift Time"} />,
      selector: (row) => {
        const shiftType = row?.shiftType?.value;
        const startTime = row?.startTime ? moment(row?.startTime).format(TIME_FORMAT_GLOBAL) : "";
        const endTime = row?.endTime ? moment(row?.endTime).format(TIME_FORMAT_GLOBAL) : "";
        const icon = (
          <img
            src={
              shiftType === "DAY"
                ? require("../../../assets/images/jsTree/shiftIcon/Sun.png")
                : require("../../../assets/images/jsTree/shiftIcon/Moon.png")
            }
          // className={className}
          // alt={imageAlt}
          />
        );

        return (
          <span onClick={() => onView(row)}>
            {icon}
            <span className="ms-2">
              {startTime} - {endTime}
            </span>
          </span>
        );
      },
      omit: type ? true : false,
      sortable: false,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: <TableTitle title={"Added On"} />,
      selector: (row) => {
        const addedOnDate = row?.createdDate ? dateToShow(row?.createdDate) : "";
        return `${addedOnDate}`;
      },
      sortable: false,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: <TableTitle title={"Applied"} />,
      selector: (row) => row?.appliedCarer,
      omit: jobStatus?.value !== JobStatusType.applied ? true : false,
      sortable: false,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: <TableTitle title={"Booked To"} />,
      selector: (row) => row?.booked?.label,
      omit: jobStatus?.value !== JobStatusType.booked ? true : false,
      sortable: false,
      style: {
        cursor: "pointer",
      },
    },

    {
      name: <TableTitle />,
      width: "100px",
      cell: (row) => (
        <>
          {/* {isAllowToAccess(UserPermissionType.job, UserActionType.add) && (
            <span className="me-3" onClick={() => onCopy(row)}>
              <div className="job-copy-icon"></div>
            </span>
          )}
          {isAllowToAccess(UserPermissionType.job, UserActionType.edit) &&
            (row.status === JobStatusType.open || row.status === JobStatusType.applied) && (
              <span onClick={() => onEdit(row)}>
                <div className="job-edit-icon"></div>
              </span>
            )} */}
          {status?.value !== "" && (
            <MoreOptions
              options={[
                {
                  icon: "copy",
                  text: "Copy",
                  action: () => {
                    onCopy(row);
                  },
                  hide: !isAllowToAccess(UserPermissionType.job, UserActionType.add),
                },
                {
                  icon: "edit",
                  text: "Edit",
                  action: () => {
                    onEdit(row);
                  },
                  hide:
                    !isAllowToAccess(UserPermissionType.job, UserActionType.edit) ||
                    !(
                      (!row?.isTimesheetCreated ||
                        row?.timesheetStatus === TimesheetStatusType.submitted ||
                        row?.timesheetStatus === TimesheetStatusType.verified) &&
                      (row?.status === JobStatusType.open ||
                        row?.status === JobStatusType.applied ||
                        row?.status === JobStatusType.booked)
                    ),
                },
                {
                  icon: "archive",
                  text: "Mark As Archive",
                  action: () => {
                    onArchive(row);
                  },
                  hide:
                    !isAllowToAccess(UserPermissionType.job, UserActionType.edit) ||
                    !(row?.status === JobStatusType.open || row?.status === JobStatusType.applied),
                },
                {
                  icon: "undo",
                  text: "ReOpen",
                  action: () => {
                    onMoveBack(row);
                  },
                  hide:
                    !isAllowToAccess(UserPermissionType.job, UserActionType.edit) ||
                    row?.status !== JobStatusType.archived ||
                    moment(row?.fromDate).isSameOrAfter(moment(), "day"),
                },
              ]}
            />
          )}
        </>
      ),
      style: {
        cursor: "pointer",
        fontSize: "20px",
        display: "flex",
        justifyContent: "end",
      },
      omit: type ? true : false,
    },
  ];
};

//***************************API's*********************************/

export function addTrainingAPI(data, weekDays, callback) {
  const params = {
    id: data?.jobId,
    fromDate: data.startDate ? moment(data.startDate).format("YYYY-MM-DD") : null,
    toDate: data.toDate ? moment(data.toDate).format("YYYY-MM-DD") : null,
    startTime: data.startTime ? moment(data.startTime).format("HH:mm") : null,
    endTime: data.endTime ? moment(data.endTime).format("HH:mm") : null,
    title: data.title,
    desc: data.desc,
    carerId: data?.carers?.id,
    days: (weekDays ?? []).filter((weekDay) => weekDay.checked)?.map((weekDay) => weekDay.value),
    status: data.status,
  };

  apiService
    .postCall(APIServicePath.saveTraining, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}
export function addJobAPI(data, weekDays, enhanceRate, callback) {
  let rateData = [];
  // data?.dayTypeRates.map((rateItem, index) => {
  //   let rates = {
  //     dayTypeId: rateItem?.dayType?.id,
  //     chargeRate: rateItem?.chargeRate ? parseFloat(rateItem?.chargeRate ?? 0) : undefined,
  //     payRate: rateItem?.payRate ? parseFloat(rateItem?.payRate ?? 0) : undefined,
  //     isPayRateChange: rateItem?.isPayRateChange ?? false,
  //     isChargeRateChange: rateItem?.isChargeRateChange ?? false,
  //   };
  //   rateData.push(rates);
  // });

  data?.dayTypeRates?.forEach((rateItem) => {
    const chargeRate = rateItem?.chargeRate ? parseFloat(rateItem.chargeRate) : undefined;
    const payRate = rateItem?.payRate ? parseFloat(rateItem.payRate) : undefined;

    if (chargeRate === undefined || payRate === undefined) return;

    rateData.push({
      dayTypeId: rateItem?.dayType?.id,
      chargeRate,
      payRate,
      isPayRateChange: rateItem?.isPayRateChange ?? false,
      isChargeRateChange: rateItem?.isChargeRateChange ?? false,
    });
  });

  let params = {
    jobId: data?.jobId,
    carerTypeId: data?.carerType.id,
    // noOfCarer: parseInt(data?.noOfCarer),
    shiftType: data?.shiftType?.value,
    fromDate: data.startDate ? moment(data.startDate).format("YYYY-MM-DD") : null,
    toDate: data.toDate ? moment(data.toDate).format("YYYY-MM-DD") : null,
    startTime: data?.startTime ? moment(data?.startTime).format("HH:mm") : null,
    endTime: data?.endTime ? moment(data?.endTime).format("HH:mm") : null,
    days: (weekDays ?? []).filter((weekDay) => weekDay.checked)?.map((weekDay) => weekDay.value),
    description: data?.description,
    poNumber: data?.poNumber,
    assignedCarerIds: data.carers?.id ? [data.carers.id] : [],
    specialityIds: data?.specialities ? data?.specialities?.map((item) => item.id) : [],
    gradeIds: data.grade?.id ? [data.grade.id] : [],
    clientId: data?.client?.id,
    wardId: data?.ward?.id,
    isMoveToRota: data?.isMoveToRota ? true : false,
    agencyId: data?.agency?.id,
    rateData: rateData ?? [],
    enhanceRate: parseFloat(enhanceRate),
  };

  apiService
    .postCall(APIServicePath.saveJob, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}
export function jobCarerAssignAPI(carer, jobDetailId, agency, jobRate, enhanceRate, callback) {
  let rateData = [];
  jobRate?.dayTypeRates.map((rateItem, index) => {
    let rates = {
      dayTypeId: rateItem?.dayType?.id,
      chargeRate: rateItem?.chargeRate,
      payRate: rateItem?.payRate,
    };
    rateData.push(rates);
  });

  let params = {
    jobId: jobDetailId,
    carerId: carer?.id,
    // agencyId: agency?.id,
    rateData: rateData,
    enhanceRate: parseFloat(enhanceRate) ?? null,
  };
  apiService
    .postCall(APIServicePath.jobAssignedCarer, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function listJobAPI(params, callback) {
  apiService
    .postCall(APIServicePath.jobList, params)
    .then((data) => {
      let list = toJobList(data?.list);
      let pageInfo = toPageInfo(data?.pageInfo);
      callback({ list, pageInfo }, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function getJobDetailAPI(params, callback) {
  apiService
    .postCall(APIServicePath.jobDetail, params)
    .then((data) => {
      let detail = toJob(data.data);
      callback(detail, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function getTrainingDetailAPI(params, callback) {
  apiService
    .postCall(APIServicePath.trainingDetail, params)
    .then((data) => {
      let detail = toJob(data.data);
      callback(detail, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function jobCarerAPI(params, callback) {
  apiService
    .postCall(APIServicePath.jobCarerList, params)
    .then((data) => {
      // let pageInfo = toPageInfo(data?.pageInfo);
      let object = toJobCarerList(data);
      callback(object, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function checkCarerAvailabilityAPI(params, callback) {
  apiService
    .postCall(APIServicePath.checkCarerAvailability, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function jobAuditTrailAPI(params, callback) {
  apiService
    .postCall(APIServicePath.jobAuditTrail, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function jobStatusUpdateAPI(params, callback) {
  apiService
    .postCall(APIServicePath.jobStatusUpdate, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}
// //***************************Converters*********************************/

function toJobList(data) {
  let list = [];
  data?.forEach((element) => {
    list.push(toJob(element));
  });
  return list;
}

function toJob(data) {
  let element = (data?.booked?.length ?? 0) > 0 ? data?.booked[0] : data?.carer ?? null;

  let carer = element
    ? {
      id: element.id,
      label: (element.firstName + " " + element.lastName).trim(),
      value: (element.firstName + " " + element.lastName).trim(),
      email: element.email,
      phone: element?.phone ? "+" + element?.countryCode + "-" + element?.phone : null,
      status: element?.status,
      isAvailable: true,
    }
    : null;

  let agency = data?.agency
    ? {
      id: data?.agency.id,
      label: data?.agency?.name,
      value: data?.agency?.name,
    }
    : null;

  let item = {
    jobId: data?.id,
    refId: data?.refId,
    agency: agency,
    booked: carer,
    carerType: data?.carerType ? convertDropValue(data?.carerType) : null,
    client: data?.client ? convertDropValue(data?.client) : null,
    ward: data?.ward,
    unitName: data?.unitName,
    appliedCarer: data?.totalApplied,
    description: data?.description,
    shiftType: data?.shiftType ? ShiftTypes.find((item) => item.value === data?.shiftType) : null,
    // noOfCarer: parseInt(data?.noOfCarerRequired),
    extraData: data?.extraData,
    poNumber: data?.poNumber,
    grade:
      (data?.grades?.length ?? 0) > 0
        ? {
          id: data?.grades[0]?.id,
          value: data?.grades[0]?.name ?? "",
          label: toCapitalize(data?.grades[0]?.name ?? ""),
          dayStart: data?.grades[0]?.dayStart ? moment(data?.grades[0]?.dayStart, "HH:mm:ss").utc().toDate() : null,
          colourHex: data?.grades[0]?.colourHex,
          nightStart: data?.grades[0]?.nightStart
            ? moment(data?.grades[0]?.nightStart, "HH:mm:ss").utc().toDate()
            : null,
        }
        : null,
    specialities: (data?.specialities ?? []).map((speciality) => convertDropValue(speciality)),
    fromDate: data.fromDate ? moment(data.fromDate).format("YYYY-MM-DD") : null,
    toDate: data.toDate ? moment(data.toDate).format("YYYY-MM-DD") : null,
    startTime: data?.startTime ? moment(data?.startTime, "HH:mm:ss").utc().toDate() : null,
    endTime: data?.endTime ? moment(data?.endTime, "HH:mm:ss").utc().toDate() : null,
    days: (data?.days?.daysFor ?? []).map((day) => {
      const foundWeekday = Weekdays.find((weekday) => weekday.value === day);
      return foundWeekday ? foundWeekday.label : "";
    }),
    serverDays: data?.days?.daysFor,
    viewListDays: (data?.days?.daysFor ?? [])
      .map((day) => {
        return day;
      })
      .join(" - "),
    isMoveToRota: data?.isRotaCreated ? true : false,
    jobCreateType: data?.jobCreateType,
    totalApplied: data?.totalApplied,
    totalAssigned: data?.totalAssigned,
    status: data?.status,
    createdDate: data?.createdDate,
    createdBy: (data?.createdBy?.firstName ?? "Anonymous") + " " + (data?.createdBy?.lastName ?? "user"),
    enhanceRate: data?.enhanceRate,
    isTimesheetCreated: data?.isTimesheetCreated,
    timesheetStatus: data?.timesheetStatus,

    // Training
    title: data?.title ?? null,
    desc: data?.description ?? null,
    trainingCarers: carer ?? null,
  };

  return item;
}

function toJobCarerList(data) {
  let assigned = (data?.assigned?.list ?? []).map((data) => {
    const assignedCarerData = {
      name: data.firstName + " " + data.lastName,
      phone: "+" + data?.countryCode + "-" + data?.phone,
      email: data?.email,
    };
    return assignedCarerData;
  });
  let applied = (data?.applied?.list ?? []).map((data) => {
    const appliedCarerData = {
      id: data?.id,
      name: data.firstName + " " + data.lastName,
      label: data.firstName + " " + data.lastName,
      phone: "+" + data?.countryCode + "-" + data?.phone,
      email: data?.email,
    };
    return appliedCarerData;
  });
  return { assigned, applied };
}
